<script>
	let img = "/assets/getgo-logo-green.png";
	import { Button, Label } from "sveltestrap";
	import CustomInput from "../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { doLogin } from "../store/auth/auth";
	import { errorMessage, loading, successMessage } from "../store/store";
	import { navigate } from "svelte-routing";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import { library } from "@fortawesome/fontawesome-svg-core";
	import { faEye as fasEye } from "@fortawesome/free-solid-svg-icons";
	import { faEyeSlash as fasEyeSlash } from "@fortawesome/free-solid-svg-icons";
	library.add(fasEye, fasEyeSlash);

	let email = "";
	let password = "";
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
	async function submit() {
		doLogin({ email, password });
	}
	let load;
	loading.subscribe((value) => {
		load = value;
	});

	const handleNavigate = (value) => {
		errorMessage.set("");
		successMessage.set("");
		navigate("forgot-password");
	};

	let show = false;

	const handleShow = () => {
		if (show) {
			show = false;
		} else {
			show = true;
		}
	};

	const onKeyPress = (e) => {
		if (e.charCode === 13) submit();
	};
</script>

<main>
	<div class="main-container">
		<div class="left">
			<div
				class="d-flex flex-column align-items-center justify-content-center w-100"
			>
				<div>
					<img
						src="/assets/getgo-logo-descriptor.png"
						alt="getgologo"
						style="width: 200px; height: 113px"
					/>
				</div>
				<div class="copyright">
					<span> Copyright © 2025. All Rights Reserved </span>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="sign-in">
				<h2>GetGo FMS</h2>
				<ErrorMessageHandler message={err} />
				<div class="mt-3 mb-1">
					<Label>
						<b>Email</b>
					</Label>
				</div>
				<div>
					<CustomInput type="email" bind:value={email} />
				</div>
				<div class="mt-3 mb-1">
					<Label>
						<b>Password</b>
					</Label>
				</div>

				<div class="position-relative">
					<CustomInput
						type={!show ? "password" : "text"}
						bind:value={password}
						keypress={onKeyPress}
					/>
					<span
						class="text-count"
						style="
                            position: absolute;
                            bottom: 27%;
                            right: 18px;"
						><i role="button" on:click={() => handleShow()}
							>{#if show}
								<FontAwesomeIcon icon={fasEye} />
							{:else}
								<FontAwesomeIcon icon={fasEyeSlash} />
							{/if}
						</i></span
					>
				</div>
				<div />
				<div class="forgot my-4">
					<a
						class="link font-weight-bold"
						on:click={() => handleNavigate()}
					>
						<b> Forgot password? </b>
					</a>
				</div>
				{#if !load}
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							on:click={submit}
							disabled={load || !email || !password}
						>
							Log in
						</Button>
					</div>
				{:else}
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							type="button"
							disabled
						>
							<span
								class="spinner-grow spinner-grow-sm"
								role="status"
								aria-hidden="true"
							/>
							Signing you in...
						</Button>
					</div>
				{/if}
			</div>
		</div>
	</div>
</main>
